// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Gf2i1","title":"styles_title__h97Rb"};